// AuthHeader is a singleton class that manages the authentication header for the application.
class AuthHeaderManager {
  private static instance: AuthHeaderManager | null = null;
  private token: string | null = null;

  private constructor() {}

  public static getInstance(): AuthHeaderManager {
    if (!AuthHeaderManager.instance) {
      AuthHeaderManager.instance = new AuthHeaderManager();
    }
    return AuthHeaderManager.instance;
  }

  public setToken(token: string): void {
    if (token.trim() === "") {
      throw new Error("Token cannot be empty");
    }

    // add Bearer prefix if it is not present
    const normalizedToken = token.startsWith("Bearer ") ? token : `Bearer ${token}`;

    this.token = normalizedToken;
  }

  public getToken(): string | null {
    return this.token;
  }

  // generate Authorization header - return empty object if token is not set
  public getAuthorizationHeader(): { Authorization?: string } {
    if (!this.token || this.token.trim().length === 0 || !this.token.startsWith("Bearer ")) {
      return {}; // return empty object
    }

    return { Authorization: this.token };
  }

  public clearToken(): void {
    this.token = null;
  }
}

export default AuthHeaderManager;
